
import { Component, Vue } from "vue-property-decorator";
import { TranslateMalay}  from "@/languages/translate_malay";
import { TranslateEn } from "@/languages/translate_en";
import Tabs from 'vue-tabs-with-active-line';
import { CarouselData } from "@/helpers/carouselData";
import UpSkillService from "../../../../services/upSkillService";
import { Constant } from "@/helpers/constant";
import JobseekerService from "../../../../services/jobseekerService";
import Jobseeker from "@/models/jobseeker";
import moment from "moment";
import RandomImageService  from "../../../../services/randomImageService";
import { DropdownData } from "@/helpers/dropdownData";
import CourseCard from "@/components/courseCard/courseCard.vue";
import jobseekerService from "@/services/jobseekerService";
@Component({  components: {
    Tabs,
    CourseCard,
  }
})

export default class Aboutusp extends Vue {
   $loading: any;
    courseDetails:any=[];
    ratingz:any=1;
    venue:any='';
    fullAddress:any='';
  courseId:any=''
  selectedLanguage: string='';
   profileId: any;
  contactUsData:any;
  currentTab:any= '1';
  slotsItem: any = CarouselData.slotsItem;
    jobseeker: Jobseeker = new Jobseeker();
  cat_id: 1;
   sloatDetails: any=[];
  tabs:any= [
      { title: 'Course Content', value: '1' },
      { title: 'Course Summary', value: '2' },
   ];
   responsiveOptionsTopCarousel:any[]= [
    {
      breakpoint: '1024px',
      numVisible: 2,
      numScroll: 1
    },
    {
      breakpoint: '900px',
      numVisible: 2,
      numScroll: 1
    },
    {
      breakpoint: '770px',
      numVisible: 1,
      numScroll: 1
    },
    {
      breakpoint: '500px',
      numVisible: 1,
      numScroll: 1
    }
  ];
  relatedCourse: any=[];
  relatedCourseLength:any=null;
  relatedkeyskils: any='';
  agencyIdValue: any=DropdownData.agencyId;
  createdByAgency: boolean = false;
  courseDetailsUrl:any = Constant.SERVER_URL+'courseDetails?courseId=';
  icNumber: any;
  applyBlockStatus: any;
  appealStatus: any;
  applealReason: any;
  editModalOpen:boolean = false;
  passportNum:any;
  courseListData:any;
  reqjobseeker = new FormData();
  programId:any;
  elearningURL:any;
  courseSessionId:any;
  handleClick(newTab) {
    this.currentTab = newTab;
    this.cat_id=1
  }

  redirectToJobseekerSignup(){
     this.$router.push("/individualSignup");
  }

  async created(){
    // this.profileId = localStorage.getItem("profileId");
    // this.icNumber = localStorage.getItem("icNumber");

    let icNum = localStorage.getItem("icNumber");
    let passprotNum = localStorage.getItem("passportNumber");

    this.profileId = localStorage.getItem("profileId");
    //this.icNumber=icNum;
    this.icNumber = passprotNum == '' || passprotNum == "null" ? icNum : '';
    this.passportNum = passprotNum == "null" ? "" : passprotNum;


    await this.getJobseekers();
    this.selectedLanguage = localStorage.getItem("selectedlanguage");
    
    this.courseId = localStorage.getItem("courseId"); 
    
    if(this.selectedLanguage == 'en')
    {
      this.contactUsData = TranslateEn.courseDetailsData;
      this.courseListData = TranslateEn.courseListData;
      this.tabs = [ {title: 'Course Content',value:'1'},
          {title: 'Course Summary',value:'2'},]
    }
      else
    {
      this.contactUsData = TranslateMalay.courseDetailsData;
      this.courseListData = TranslateMalay.courseListData;
      this.tabs = [ {title: 'Kandungan Kursus',value:'1'},
          {title: 'Ringkasan Kursus',value:'2'},]
    }

    this.slotsItem=this.slotsItem[0].data;
    this.getCourseDetails();
  }

  backToDashboard(){
    // this.$router.push("/individualDashboard")
    history.back();
  }

   getCourseDetails() {

    console.log('load course api')
    let loader = this.$loading.show();
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER,
      id:this.courseId
    };
    UpSkillService.getCourseDetails(data).then((response) => {
      loader.hide();
      if (response != undefined) {
        if (response.data.statusCode == 200) {
          if (response.data != undefined && response.data != null && response.data.data.data.courses[0] !='' && response.data.data.data.courses[0] != null && response.data.data.data.courses[0] != undefined )
           {
            this.courseDetails = response.data.data.data.courses[0];
            this.sloatDetails= response.data.data.data.courses[0].courseSessions;
            this.relatedkeyskils = this.courseDetails.keySkillId;
            this.ratingz = response.data.data.data.rating;
            this.programId = response.data.data.data.courses[0].programId;
            this.courseSessionId = response.data.data.courses[0].courseSessions[0].id;
            console.log('course session id')
            console.log(this.courseSessionId)
            // if(response.data.data.data.courses[0].courseVenue.length > 0) {
            //   this.fullAddress = response.data.data.data.courses[0].courseVenue[0].venue[0];
            //   this.venue = this.fullAddress.address+', '+this.fullAddress.city+', '+this.fullAddress.postcode+', '+this.fullAddress.state;
            // }

            const venue = response?.data?.data?.data?.courses?.[0]?.courseVenue?.[0]?.venue?.[0];

            if (venue) {
              this.fullAddress = venue;

              this.venue = [
                venue.address,
                venue.city,
                venue.postcode,
                venue.state
              ]
                .filter(Boolean)
                .join(', ');
            }
          
            this.createdBy(this.courseDetails.createdBy);
            localStorage.removeItem("entrol"); 
            // console.log('testetststss t mode')
            // console.log(this.courseDetails.trainingMode)
            this.courseDetails.trainingMode2 = this.courseDetails.trainingMode;
            this.courseDetails.pillar2 = this.courseDetails.pillar;
            const translation = this.selectedLanguage === 'en'
              ? TranslateEn.courseDetailsData
              : TranslateMalay.courseDetailsData;

            const trainingModeMap = {
              'Blended/Hybrid': translation.blendHybrid,
              'Blended / Hybrid': translation.blendHybrid,
              'Classroom': translation.classRoom,
              'Coaching': translation.coaching,
              'e-Learning': translation.eLearning,
              'ROT_Virtual_Training': translation.onlineTraining,
              'Online': translation.onlineTraining
            };

            this.courseDetails.trainingMode2 =
              trainingModeMap[this.courseDetails.trainingMode] ||
              this.courseDetails.trainingMode;
             
            const pillarMap = {
              'Life Skills': translation.lifeSkill,
              'Future Skills': translation.futureSkill,
              'Creativity & Innovation': translation.creativityInnovation,
              'Financial': translation.financial,
              'Sustainable Development': translation.sustainableDev,
            };

            this.courseDetails.pillar2 =
              pillarMap[this.courseDetails.pillar] ||
              this.courseDetails.pillar;

             this.getRelatedCourse();
             
           }else{
             this.courseDetails=[];
           }
        }
      }
    });
  }

  async getJobseekers() {
    const loader = this.$loading.show();

    if (!this.$store.getters['dashboard/getJobseekerData']) {
      await this.$store.dispatch('dashboard/fetchJobseekerData')
    }

    loader.hide()

    this.jobseeker = this.$store.getters['dashboard/getJobseekerData']
    this.applyBlockStatus = this.$store.getters['dashboard/getJobseekerData'].courseApplyStatus;
    this.appealStatus = this.$store.getters['dashboard/getJobseekerData'].appealStatus;
  
    // JobseekerService.getJobSeekerById(this.profileId).then(
    //   (response) => {
    //     loader.hide();
    //     if (response != undefined && response.data != undefined) {
    //       if (response.data.status == 200) {
    //         if (response.data.data != null && response.data.data.length > 0) {
    //           this.jobseeker = response.data.data[0];
    //           this.applyBlockStatus = response.data.data[0].courseApplyStatus;
    //           this.appealStatus = response.data.data[0].appealStatus;
    //         }
    //       }
    //     }
    //   }
    // );
  }

  applyCourseForTrainee(course){
    let reqdata ={
      provider:Constant.JOBSEEKER_PROVIDER,
      nricnumber:this.jobseeker.icNumber,
      status:Constant.APPLIED,
      courseName:course.course.Name,
      progName:course.course.Name,
      trainingHour:course.trainingHours,
      trainingStartDate:course.trainingStartDate,
      trainingEndDate:course.trainingEndDate,
      traineeName:this.jobseeker.candidateName,
      agencyName: course.trainingProvider,
      email:this.jobseeker.email
    };
      let loader = this.$loading.show();
      JobseekerService.applyCourseForJobseeker(reqdata).then(
        data => {
          loader.hide();
          
          if (data != undefined && data.data != undefined) {
            if (data.data.status == 200) {
              if(data.data.update == 1){
              alert("Course Applied");
              this.getJobseekers();
              }
              else{
              alert("We are unable to process your application. Please try again");
              this.getJobseekers();
              }
            } else {
              alert("We are unable to process your application. Please try again");
              this.getJobseekers();
            }
          }
        }
      );
  }



   redirectToCourseElearning(url) {

      if (!url) {
          console.error('Course URL is empty.');
          return;
      }

      this.submitPreReg(url);

      // window.open(url, '_blank');
  }


  submitPreReg(url) {
    let loader = this.$loading.show();

    const strToSnakeCase = (key) =>
        key &&
        key
          .match(
            /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g
          )
          .map((x) => x.toLowerCase())
          .join("_");
      for (let key in this.jobseeker) {
        if (
          this.jobseeker[key] != undefined &&
          this.jobseeker[key] != null
        ) {
          this.reqjobseeker.append(
            strToSnakeCase(key),
            this.jobseeker[key]
          );
        }
      }
      this.reqjobseeker.append("provider", Constant.JOBSEEKER_PROVIDER);
      this.reqjobseeker.append("program_id", this.programId);
      this.reqjobseeker.append("course_id", this.courseId);  
      // this.reqjobseeker.append("course_session_id", this.courseSessionId);
      this.reqjobseeker.append("course_session_id", this.courseDetails.courseSessions[0].id);
 
    jobseekerService.preRegJobseeker(this.reqjobseeker, Constant.JOBSEEKER_PROVIDER).then(
      (response) => {
        loader.hide();
        if (response != undefined && response.data != undefined) {
          if (response.data.statusCode == 200) {
            this.jobseeker = response.data.data;
            //alert("Your Pre-Registration has been done Successfully.");
            window.open(url, '_blank');
            //alert( response.data.data.message)
            //  this.$fire({title: 'Success',text: "Your Pre-Registration has been done Successfully.",showCancelButton: false,confirmButtonText: 'OK',type: "success",
            //   backdrop: `
            //   rgba(0,0,1,0.4)
            //   center left
            //   no-repeat
            // `})

              //this.$router.push(url);
          } else {
              //this.$router.push(url);
              window.open(url, '_blank');
            // alert(
            //   "Your Pre-Registration has not been done successfully. Please try again."
            // );
             //alert( response.data.data.message)
            // this.$fire({title: 'Success',text: "Your Pre-Registration has been done Successfully.",showCancelButton: false,confirmButtonText: 'OK',type: "success",
            //   backdrop: `
            //   rgba(0,0,1,0.4)
            //   center left
            //   no-repeat
            // `})
            this.jobseeker = new Jobseeker();
          }
        }
      }
    );
  }


 applyCourseInSW(pgmId,courseId,courseSessionID,course){
  //  alert(JSON.stringify(course))
   if(this.applyBlockStatus != 1){
    let req = {
      provider: Constant.JOBSEEKER_PROVIDER,
      program_id: pgmId,
      course_id: courseId,
      name: this.jobseeker.candidateName,
      email: this.jobseeker.email,
      nric_number: this.icNumber,
      passport_number : this.passportNum,
      phone: this.jobseeker.mobileNumber,
      gender: '',
      marital_status: '',
      ethnicity: '',
      date_of_birth: '',
      address: '',
      country: '',
      state: '',
      city: '',
      postal_code: '',
      current_status: '',
      expected_salary:'',
      preferred_industry:'',
      preferred_work_location:'',
      preferred_job_category:'',
      preferred_work_position: '',
      preferred_skills: this.jobseeker.keySkills,
      work_position_title: '',
      work_role: '',
      work_type_of_job: '',
      work_job_category: '',
      work_company_name: '',
      work_industry: '',
      work_specialization: '',
      work_monthly_salary: '',
      work_is_current_company: '',
      work_start_date: '',
      work_end_date: '',
      work_position_level: '',
      work_job_description: '',
      education_highest_qualification: '',
      education_specialization: '',
      education_institute: '',
      education_passing_year: '',
      education_cgpa: '',
      course_session_id:courseSessionID,
      employment_current_location:''
    };
    // if(this.jobseeker.jobseekerPersonalDetails.length > 0){
    //   if(this.jobseeker.jobseekerPersonalDetails[0].gender != undefined)
    //    req['gender'] = this.jobseeker.jobseekerPersonalDetails[0].gender;
    //   if(this.jobseeker.jobseekerPersonalDetails[0].maritalStatus != undefined)
    //    req['marital_status'] = this.jobseeker.jobseekerPersonalDetails[0].maritalStatus;
    //   if(this.jobseeker.jobseekerPersonalDetails[0].ethnicity != undefined)
    //    req['ethnicity'] = this.jobseeker.jobseekerPersonalDetails[0].ethnicity;
    //   if(this.jobseeker.jobseekerPersonalDetails[0].dobMonth != undefined)
    //    req['date_of_birth'] = this.formatDate(this.jobseeker.jobseekerPersonalDetails[0].dobMonth);
    //   if(this.jobseeker.jobseekerPersonalDetails[0].permanentAddress != undefined)
    //    req['address'] = this.jobseeker.jobseekerPersonalDetails[0].permanentAddress;
    //    if(this.jobseeker.jobseekerPersonalDetails[0].homeTown != undefined)
    //    req['country'] = this.jobseeker.jobseekerPersonalDetails[0].homeTown;
    //    if(this.jobseeker.jobseekerPersonalDetails[0].state != undefined)
    //    req['state'] = this.jobseeker.jobseekerPersonalDetails[0].state;
    //    if(this.jobseeker.jobseekerPersonalDetails[0].homeTown != undefined)
    //    req['city'] = this.jobseeker.jobseekerPersonalDetails[0].homeTown;
    //    if(this.jobseeker.jobseekerPersonalDetails[0].pinCode != undefined)
    //    req['postal_code'] = this.jobseeker.jobseekerPersonalDetails[0].pinCode;
    // }
    // if(this.jobseeker.currentStatus != undefined){
    //   req['current_status'] = this.jobseeker.currentStatus;
    // }
    // if (this.jobseeker.totalWorkExperienceInYrs != undefined) {
    //   req["total_work_experience_in_yrs"] = this.jobseeker.totalWorkExperienceInYrs;
    // }
    // if (this.jobseeker.totalWorkExperienceInMonths != undefined) {
    //   req["total_work_experience_in_months"] = this.jobseeker.totalWorkExperienceInMonths;
    // }
    // if (this.jobseeker.currentLocation != undefined) {
    //   req["employment_current_location"] = this.jobseeker.currentLocation;
    // }
    //  if(this.jobseeker.jobseekerCareerProfile.length > 0){
    //   if(this.jobseeker.jobseekerCareerProfile[0].expectedSalaryInThousands != undefined )
    //    req['expected_salary'] = this.jobseeker.jobseekerCareerProfile[0].expectedSalaryInThousands;
    //   if(this.jobseeker.jobseekerCareerProfile[0].industry != undefined)
    //    req['preferred_industry'] = this.jobseeker.jobseekerCareerProfile[0].industry;
    //   if(this.jobseeker.jobseekerCareerProfile[0].preferredJobLocation != undefined)
    //    req['preferred_work_location'] = this.jobseeker.jobseekerCareerProfile[0].preferredJobLocation;
    //   if(this.jobseeker.jobseekerCareerProfile[0].jobCategory != undefined)
    //    req['preferred_job_category'] = this.jobseeker.jobseekerCareerProfile[0].jobCategory;
    //   if(this.jobseeker.jobseekerCareerProfile[0].workPosition != undefined)
    //    req['preferred_work_position'] = this.jobseeker.jobseekerCareerProfile[0].workPosition;
    // }

    //  if(this.jobseeker.jobseekerEmployments.length > 0){
    //   if(this.jobseeker.jobseekerEmployments[0].designation != undefined)
    //    req['work_position_title'] = this.jobseeker.jobseekerEmployments[0].designation;
    //   if(this.jobseeker.jobseekerEmployments[0].specializationSubCategory != undefined)
    //    req['work_role'] = this.jobseeker.jobseekerEmployments[0].specializationSubCategory;
    //    if(this.jobseeker.jobseekerEmployments[0].jobType != undefined)
    //    req['work_type_of_job'] = this.jobseeker.jobseekerEmployments[0].jobType;
    //     if(this.jobseeker.jobseekerEmployments[0].jobCategory != undefined)
    //    req['work_job_category'] = this.jobseeker.jobseekerEmployments[0].jobCategory;
    //     if(this.jobseeker.jobseekerEmployments[0].organization != undefined)
    //    req['work_company_name'] = this.jobseeker.jobseekerEmployments[0].organization;
    //     if(this.jobseeker.jobseekerEmployments[0].industry != undefined)
    //    req['work_industry'] = this.jobseeker.jobseekerEmployments[0].industry;
    //     if(this.jobseeker.jobseekerEmployments[0].specialization != undefined)
    //    req['work_specialization'] = this.jobseeker.jobseekerEmployments[0].specialization;
    //     if(this.jobseeker.jobseekerEmployments[0].annualSalaryInthousands != undefined)
    //    req['work_monthly_salary'] = this.jobseeker.jobseekerEmployments[0].annualSalaryInthousands.toString();
    //     if(this.jobseeker.jobseekerEmployments[0].isCurrentCompany != undefined)
    //    req['work_is_current_company'] = this.jobseeker.jobseekerEmployments[0].isCurrentCompany;
    //    if(this.jobseeker.jobseekerEmployments[0].workingFromInyears != undefined)
    //    req['work_start_date'] = this.formatDate(this.jobseeker.jobseekerEmployments[0].workingFromInyears);
    //    if(this.jobseeker.jobseekerEmployments[0].workedTill != undefined)
    //    req['work_end_date'] = this.formatDate(this.jobseeker.jobseekerEmployments[0].workedTill);
    //     if(this.jobseeker.jobseekerEmployments[0].positionLevel != undefined)
    //    req['work_position_level'] = this.jobseeker.jobseekerEmployments[0].positionLevel;
    //     if(this.jobseeker.jobseekerEmployments[0].jobProfileDescription != undefined)
    //    req['work_job_description'] = this.jobseeker.jobseekerEmployments[0].jobProfileDescription;
    // }
    // if(this.jobseeker.jobseekerEducations.length > 0){
    //   if(this.jobseeker.jobseekerEducations[0].qualificationSubCategory != undefined)
    //    req['education_highest_qualification'] = this.jobseeker.jobseekerEducations[0].qualificationSubCategory;
    //     if(this.jobseeker.jobseekerEducations[0].specialization != undefined)
    //    req['education_specialization'] = this.jobseeker.jobseekerEducations[0].specialization;
    //     if(this.jobseeker.jobseekerEducations[0].instituteName != undefined)
    //    req['education_institute'] = this.jobseeker.jobseekerEducations[0].instituteName;
    //     if(this.jobseeker.jobseekerEducations[0].passingYear != undefined)
    //    req['education_passing_year'] = this.jobseeker.jobseekerEducations[0].passingYear;
    //     if(this.jobseeker.jobseekerEducations[0].percentage != undefined)
    //    req['education_cgpa'] = this.jobseeker.jobseekerEducations[0].percentage;
    // }
    let loader = this.$loading.show();
    UpSkillService.applyCourseForJobseeker(req).then((response) => {

      // console.log('enrol')
      // console.log(response)
      loader.hide();
      debugger;
       if (response.data.error != true) {
        // this.applyCourseForTrainee(course);
        //  this.$swal('Hello Vue world!!!');
         this.$fire({title: 'Success',text: "Successfully enrolled course",showCancelButton: false,confirmButtonText: 'OK',type: "success",
              backdrop: `
              rgba(0,0,1,0.4)
              center left
              no-repeat
              `})
      }else {
         if (response.data.data.required) {
           this.$fire({
              title: 'Error',
              text: JSON.stringify(response.data.data.required) + " Kindly update the fields in your profile to apply for course.",
              showCancelButton: false,
              confirmButtonText: 'OK',
              type: "error",
              backdrop: `
              rgba(0,0,1,0.4)
              center left
              no-repeat
              `})
        // alert(JSON.stringify(response.data.data.required) + " Kindly update the fields in your profile to apply for course.");
        this.getJobseekers();
         }else {
             this.$fire({
              title: '',
              text: response.data.data.message,
              showCancelButton: false,
              confirmButtonText: 'OK',
              type: "info",
              backdrop: `
              rgba(0,0,1,0.4)
              center left
              no-repeat
              `})
              this.getJobseekers();
         }
      }
    });
  } else{
  
   if(this.appealStatus == 0){
  this.$fire({
              title: '',
              text: "Course Application has been temporarily blocked. Kindly submit an Appeal to re-activate",
              showCancelButton: true,
              confirmButtonText: 'Appeal',
              type: "info",
              backdrop: `
              rgba(0,0,1,0.4)
              center left
              no-repeat
              `}).then((Okay) => {
        if(Okay.value){
          this.openAppealForm();
        }
    });
   }else if(this.appealStatus == 1){
  this.$fire({
              title: '',
              text: "Course Application has been temporarily blocked. Your Already Appeal to re-activate",
              showCancelButton: false,
              confirmButtonText: 'Ok',
              type: "info",
              backdrop: `
              rgba(0,0,1,0.4)
              center left
              no-repeat
              `})
   }else if(this.appealStatus == 3){
       this.$fire({
              title: '',
              text: "Course Application has been temporarily blocked. Your appeal has been rejected",
              showCancelButton: false,
              confirmButtonText: 'Ok',
              type: "info",
              backdrop: `
              rgba(0,0,1,0.4)
              center left
              no-repeat
              `})
   }
  }
  }
    formatDate(value){
     let val = moment(String(value)).format('Y-MM-DD');
     if(val == "Invalid date"){
       return "";
     }
     else{
       return val;
     }
  }
     formatDateVal(value){
     let val = moment(String(value)).format('DD MMM YYYY');
     if(val == "Invalid date"){
       return "";
     }
     else{
       return val;
     }
  }


    formatTime(value){
    let val = value.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [value];

  if (val.length > 1) { // If time format correct
    val = val.slice (1);  // Remove full string match value
    val[5] = +val[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
    val[0] = +val[0] % 12 || 12; // Adjust hours
  }
  val=val[0]+val[1]+ val[2]+' '+val[5];
     if(val == "Invalid time"){
      return ""
     }
     else{
       return val
     }
  }

    bannerImage(data:any[]){
      for (let index = 0; index < data.length; index++) {
          if (data[index].fileType == "courseBanner") {
                let url = "";
          if (
            data[index].fileUrl != undefined && data[index].fileUrl != null && data[index].fileUrl != ""
          ) {
            url = data[index].fileUrl.replace(
              Constant.OSSInternalURL,
              Constant.OSSReplaceURL
            );
            return url;
          }
          }
      }
      return null;
 }

 referenceAttachment(fileUrl){
      // for (let index = 0; index < data.length; index++) {
          // if (data[index].fileType == "courseBanner") {
          let url = "";
          if (
            fileUrl != undefined && fileUrl != null && fileUrl != ""
          ) {
            url = fileUrl.replace(
              Constant.OSSInternalURL,
              Constant.OSSReplaceURL
            );
            return url;
          }
          // }else{
          //   return null;
          // }
      // }
 }

allCourse:any[];
     getRelatedCourse() {
    let loader = this.$loading.show();
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER,
      filter:'',
      menu:'',
      keyskill:this.relatedkeyskils
    };
    UpSkillService.gethomeCourseCount(data).then(
      (response) => {
        loader.hide();


        if (response != undefined) {
          if (response.data.statusCode == 200) {
            if (
              response.data != undefined &&
              response.data != null 
            )
           { 
             let courseArry=[]
               this.allCourse =response.data.data.data.courses.data;
           for (let index = 0; index < this.allCourse.length; index++) {
                 if (this.allCourse[index].id != this.courseId) {
                    courseArry.push(this.allCourse[index]);
                 }
           }
           this.relatedCourse = courseArry;
             this.relatedCourseLength=this.relatedCourse.length;
           }
          }
        }
      }
    );
  }
 relatedCourseDetails(courseId){
    localStorage.setItem("courseId",courseId)
    this.$router.push("/indiCourse?courseId="+courseId);
    this.courseId = courseId;
    this.getCourseDetails();
    window.scroll(0,0);
 }
 randomImage(){
    return RandomImageService.randomImage();
  }
  randomCpImage(){
    return RandomImageService.randomCpImage();
  }
    createdBy(id:any) {
     for (let index = 0; index < this.agencyIdValue.length; index++) {
        if(this.agencyIdValue[index] == id){
           this.createdByAgency = true;
        } 
      }
    }

    
  copyUrl(courseId){
      let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = Constant.PLATFORM_URL+'courseDetails?courseId='+courseId;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
      this.$toast.add({severity:'success', summary: 'Success', detail:'Course Link Copied To Clipboard', life: 3000});
  }

openAppealForm(){
  this.editModalOpen = true;
}
cancelAppeal(){
  this.editModalOpen = false;
}
  appealFromAdminStatus() {
    let data ={
       provider: Constant.JOBSEEKER_PROVIDER,
       id: this.profileId,
       appeal_status: 1,
       appeal_reason: this.applealReason
    };
    let loader = this.$loading.show();
    JobseekerService.appealFromAdminStatus(data).then(response => {
      loader.hide();
      if (response != undefined) {
        if (response.status == 200) {
          if(response.data != undefined && response.data != null && response.data.data != undefined && response.data.data != null)
          {
   this.$fire({title: 'Success',text: "Appeal Successfully Sent!",showCancelButton: false,confirmButtonText: 'OK',type: "success",
              backdrop: `
              rgba(0,0,1,0.4)
              center left
              no-repeat
              `})
               this.editModalOpen = false;
               this.applealReason = "";
               this.getJobseekers();
          }
        }
      }
    });
  }
  dateTimeNow() {
  var now = new Date();
  var dateString = moment(now).format('YYYY-MM-DD');

  var dateStringWithTime = moment(now).format('YYYY-MM-DD HH:mm:ss');
  return dateStringWithTime;
}

plusDuration(time,date,duration) {
  let hello = '';
  hello = date+' '+time;
  duration = 0;
  return moment(hello).add(duration, 'h').format('YYYY-MM-DD HH:mm:ss');
}

formatCurrency(value) {
    if (value != null) {
        const numberValue = parseFloat(value);
        if (!isNaN(numberValue)) {
            return 'RM ' + numberValue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        }
    }
    return 'RM 0.00';
}

formatRating(value) {
    if (value != null) {
        const numberValue = parseFloat(value);
        if (!isNaN(numberValue)) {
            return numberValue.toFixed(2);
        }
    }
    return '0';
}
}
